import type { BaseServiceOptions, Pagination } from '@/core/types'
import {
  TInvitationStatistics,
  TSeller,
  moduleServiceHandlers,
  catalogServiceHandlers,
  serviceConfig,
} from '../../..'
import { useNotification } from '@/core'
import { useQuery } from '@tanstack/vue-query'
import { AxiosError } from 'axios'

const { invitations } = serviceConfig

export const useModuleQuery = (options: BaseServiceOptions<Pagination>) => {
  const { currentPage, enableQuery, filters } = options

  const { errorHttpNotification } = useNotification()

  const loadInvitationStatistics = useQuery<TInvitationStatistics, AxiosError>(
    [invitations.model, currentPage, filters?.loadInvitationStatistics],
    () =>
      moduleServiceHandlers.loadInvitationStatistics({
        dynamicFilters: filters?.loadInvitationStatistics,
        page: currentPage,
      }),
    {
      refetchOnWindowFocus: false,
      enabled: enableQuery?.loadInvitationStatistics,
      onError: (error) => errorHttpNotification(error),
    },
  )

  const sellersCatalog = useQuery<TSeller[]>(
    [serviceConfig.sellers],
    () => catalogServiceHandlers.sellersCatalog.loadCatalog({}),
    {
      refetchOnWindowFocus: false,
      enabled: enableQuery?.sellersCatalog,
    },
  )

  return {
    loadInvitationStatistics,
    sellersCatalog,
  }
}
